var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import GenericTable from "../../../../../../../shared-library/components/GenericTable";
import { Row, Col } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import GenericSidebar from "@frameworks/web/components/generic/Sidebar/GenericSidebar";
import AddRequest from "./AddRequest";
import { useSelector } from "react-redux";
import di from "../../../di/serviceLocator";
var ExceptionTable = function (props) {
    var initialObj = {
        selectSegment: "",
        selectedsinState: {},
        expiryDate: "",
        uppercap: "",
        haircut: "",
        remarks: "",
    };
    var _a = __read(React.useState(false), 2), addRequest = _a[0], setAddRequest = _a[1];
    var _b = __read(React.useState([]), 2), getExceptionDetails = _b[0], setGetExceptionDetails = _b[1];
    var _c = __read(React.useState([]), 2), tableDetails = _c[0], setTableDetails = _c[1];
    var _d = __read(React.useState(), 2), addRequestData = _d[0], setAddRequestData = _d[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var overviewData = useSelector(function (state) { return state.Clients.ClientOverview.reducersData.data; });
    var getExceptionDetailsData = function (data) {
        di.clients
            .getExceptionData(data)
            .then(function (responsedata) {
            if (responsedata) {
                setGetExceptionDetails(responsedata);
                setTableDetails(responsedata);
            }
        })
            .catch(function (error) {
            console.log("Exception Data err", error);
        });
    };
    React.useEffect(function () {
        getExceptionDetailsData({
            Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            searchText: null,
        });
    }, [selectedAcount]);
    var saveExceptionData = function () {
        var _a, _b, _c, _d;
        var payloads = {
            clientCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            clientName: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.clientName,
            isin: (_a = addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.selectedsinState) === null || _a === void 0 ? void 0 : _a.v_isin,
            scripName: (_b = addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.selectedsinState) === null || _b === void 0 ? void 0 : _b.v_scrip_name,
            expiryDate: addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.expiryDate,
            upperCap: addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.uppercap,
            segment: addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.selectSegment,
            segmentid: "",
            isNew: "",
            remarks: addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.remarks,
            id: "",
            scripCode: (_c = addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.selectedsinState) === null || _c === void 0 ? void 0 : _c.v_scripcode,
            createdBy: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.userName,
            hairCut: addRequestData === null || addRequestData === void 0 ? void 0 : addRequestData.haircut,
            acceptedUppercap: "",
            entryType: (_d = overviewData === null || overviewData === void 0 ? void 0 : overviewData.lob) !== null && _d !== void 0 ? _d : "",
            isEdit: "",
            status: "1",
            acceptedHaircut: "",
            approverRemarks: "",
        };
        console.log("Save Exception Payloads", payloads);
        di.clients
            .saveExceptionHaircut(payloads)
            .then(function (saveResponse) {
            console.log("Save Exception Success", saveResponse);
        })
            .catch(function (error) {
            console.log("Save Exception fail", error);
        });
    };
    var searchTextExceptionPage = function (enteredTxts) {
        console.log("entred search data", enteredTxts);
        if (!!enteredTxts) {
            var newTableData = tableDetails.filter(function (item) {
                return Object.values(item).some(function (value) {
                    if (typeof value == "string" &&
                        (value === null || value === void 0 ? void 0 : value.toLowerCase().includes(enteredTxts.toLowerCase())))
                        return true;
                    else
                        return false;
                });
            });
            setTableDetails(newTableData);
        }
        else if (!enteredTxts && getExceptionDetails.length == 0) {
            getExceptionDetailsData({
                Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                searchText: null,
            });
        }
        else {
            setTableDetails(__spreadArray([], __read(getExceptionDetails), false));
        }
    };
    var exceptionColumns = [
        {
            columnName: "ClientId",
            key: "clientCode",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Client Name",
            key: "clientName",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "ISIN",
            key: "isin",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Scip Code",
            key: "scripCode",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Scip Name",
            key: "scripName",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Expiry Date",
            key: "expiryDate",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Segment",
            key: "segment",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Upper Cap",
            key: "upperCap",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Hair Cut(%)",
            key: "hairCut",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Status",
            key: "status",
            tdCustomFunction: function (key) {
                return React.createElement("div", { className: "txt-dark-red" }, key ? key : "-");
            },
        },
        {
            columnName: "Dealer Remarks",
            key: "remarks",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Approver Remarks",
            key: "approverRemarks",
            tdCustomFunction: function (key) {
                return React.createElement("div", null, key ? key : "-");
            },
        },
        {
            columnName: "Action",
            key: "",
            tdCustomFunction: function () {
                return (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Edit", onClick: function () {
                        setAddRequest(true);
                    } }));
            },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.closePopup(false);
                            } }),
                        "Exception")))),
        React.createElement("div", { className: "exception-body" },
            React.createElement("div", { className: "d-flex justify-content-end exception-search align-items-center" },
                React.createElement("div", { className: "d-flex txt-midnight-blue align-items-baseline hand_cursor", onClick: function () {
                        setAddRequest(true);
                        setAddRequestData(initialObj);
                    } },
                    React.createElement("i", { className: "edel-icon-rounded-plus me-2" }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Add New Request" })),
                React.createElement("div", { className: "search-input" },
                    React.createElement(InputField, { placeholderClassName: "", placeholder: "Search", onChangeEvent: function (e) {
                            searchTextExceptionPage(e.target.value);
                        } }))),
            React.createElement(GenericTable, { columns: exceptionColumns, data: tableDetails, parentClassName: "salestableParentClass table-responsive commonscroll-new exception-table", tableClassName: "salestableclass w-100", rowOnClick: function (x) {
                    setAddRequestData({
                        selectSegment: x.segment,
                        selectedsinState: {
                            v_isin: x.isin,
                            v_scrip_name: x.scripName,
                            v_scripcode: x.scripCode,
                        },
                        expiryDate: x.expiryDate,
                        uppercap: x.upperCap,
                        haircut: x.hairCut,
                        remarks: x.remarks,
                    });
                } })),
        React.createElement(GenericSidebar, { parentClassname: "exception-sidebar sidebar-scroll", arrowClose: true, header: React.createElement("div", { className: "txt_blackOne1 DMSans_16_500 px-0 exception-head" }, "Add New Request"), body: React.createElement(AddRequest, { addRequestData: addRequestData, setAddRequestData: setAddRequestData }), footer: React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: "w-100 mx-3", onClick: function () {
                    saveExceptionData();
                } }), openKey: addRequest, setOpenKey: setAddRequest })));
};
export default ExceptionTable;
